enum DecimalSeparators {
    COMMA = 'comma',
    POINT = 'point',
}

export default DecimalSeparators
